import React, { useEffect, useState } from "react";
import { Avatar, Grid, Stack, TextField, Typography } from "@mui/material";
import { digiLockerStatusAPICall } from "../../shared/APICalls";
import JsonStyles from "./JsonData.module.scss";

interface Props {
  aadhaarData: any;
}

export default function JsonDataToAadhaarFormat({ aadhaarData }: Props) {
  const [fetechedDetails, setfetechedDetails] = useState(true);

  return (
    <>
      {fetechedDetails ? (
        <Stack alignItems={"center"} height={"max-content"} width={"100%"}>
          <p className={JsonStyles.header}>Fetched Aadhaar Details</p>

          <div className={JsonStyles.containerData}>
            <Grid
              margin={"0px 0"}
              sx={{
                borderRadius: "50%",
                border: { xs: "none", sm: "1px solid #E5E7EB" },
                width: "110px",
                height: "110px",
                transform: "rotate(45deg)",
                position: "absolute",
                top: "-50px",
              }}
            >
              <img
                src={aadhaarData?.url}
                alt="Certificate"
                style={{
                  width: "100px",
                  height: "100px",
                  border: "5px solid white",
                  borderRadius: "50%",
                  transform: "rotate(-45deg)",
                }}
              />
            </Grid>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
              sx={{ paddingTop: "50px" }}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                      background: "#F9FAFB",
                      borderRadius: "30px",
                    },
                  }}
                  id="outlined-basic"
                  label="Aadhaar No"
                  variant="outlined"
                  value={aadhaarData?.aadhaar_no}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  // focused
                  id="outlined-basic"
                  label="Name"
                  variant="outlined"
                  value={aadhaarData?.name}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                      background: "#F9FAFB",
                      borderRadius: "30px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  // focused
                  id="outlined-basic"
                  label="Date of Birth"
                  variant="outlined"
                  value={aadhaarData?.dob}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                      background: "#F9FAFB",
                      borderRadius: "30px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  // focused
                  id="outlined-basic"
                  label="Gender"
                  variant="outlined"
                  value={aadhaarData?.gender}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                      background: "#F9FAFB",
                      borderRadius: "30px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  // focused
                  id="outlined-basic"
                  label="Address"
                  variant="outlined"
                  value={aadhaarData?.address}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                      background: "#F9FAFB",
                      borderRadius: "30px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Stack>
      ) : (
        <Stack>
          <Typography>No Details Fetched</Typography>
        </Stack>
      )}
    </>
  );
}
